const RemoteStart = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M42.8714 14.2907C40.6668 12.2471 37.7287 11 34.5026 11C31.2766 11 28.3385 12.2471 26.1338 14.2907M28.8741 17.0656C30.3751 15.7281 32.3452 14.9168 34.5027 14.9168C36.6602 14.9168 38.6303 15.7281 40.1312 17.0656"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="34.5026" cy="24.4177" r="2.69599" stroke="currentColor" strokeWidth="1.5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.2223 23.9995C26.5976 25.4572 23.2441 29.7803 23.2441 34.8866V47.5506C23.2441 53.8539 28.3539 58.9637 34.6572 58.9637C40.9605 58.9637 46.0703 53.8539 46.0703 47.5506V34.8866C46.0703 29.6726 42.574 25.2753 37.798 23.9111C37.6491 24.42 37.3862 24.8799 37.0389 25.2615C41.3634 26.328 44.5703 30.2328 44.5703 34.8866V47.5506C44.5703 53.0255 40.132 57.4637 34.6572 57.4637C29.1824 57.4637 24.7441 53.0255 24.7441 47.5506V34.8866C24.7441 30.3259 27.824 26.4845 32.0173 25.3289C31.6595 24.9563 31.3846 24.5032 31.2223 23.9995Z"
      fill="currentColor"
    />
    <path
      d="M34.657 54.523C38.6211 54.523 41.8346 51.3095 41.8346 47.3455C41.8346 43.3815 38.6211 40.168 34.657 40.168C30.693 40.168 27.4795 43.3815 27.4795 47.3455C27.4795 51.3095 30.693 54.523 34.657 54.523Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.8626 45.1674C32.8626 44.8248 32.8626 44.6535 32.9342 44.5579C32.9966 44.4745 33.0921 44.4224 33.196 44.415C33.3151 44.4065 33.4592 44.4991 33.7474 44.6844L37.1356 46.8625C37.3856 47.0232 37.5107 47.1036 37.5538 47.2058C37.5916 47.2951 37.5916 47.3959 37.5538 47.4852C37.5107 47.5874 37.3856 47.6678 37.1356 47.8285L33.7474 50.0067C33.4592 50.1919 33.3151 50.2845 33.196 50.276C33.0921 50.2686 32.9966 50.2165 32.9342 50.1331C32.8626 50.0375 32.8626 49.8662 32.8626 49.5236V45.1674Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M30.0947 31.1846H38.9102" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default RemoteStart;
